import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import AuthLayout from 'src/components/layout/AuthLayout';
import NotFoundContent from 'src/components/layout/NotFoundContent';
import useUser from 'src/hooks/useUser';
import { AccessCodesSchema } from 'src/hooks/useAccessCodesEffect';
import { z } from 'zod';
import useSkeletonCleanup from 'src/init/useSkeletonCleanup';

const AuthPage = () => {
  const { accessCodes, courseId, moduleId } = Route.useSearch();
  const { user, loading } = useUser();
  useSkeletonCleanup(loading);

  if (user?.clientId) {
    if (courseId) {
      if (moduleId) {
        return (
          <Navigate
            params={{ courseId: String(courseId) }}
            search={{ materialId: Number(moduleId) }}
            to="/courses/$courseId"
          />
        );
      }

      return (
        <Navigate
          params={{ courseId: String(courseId) }}
          to="/courses/$courseId/details"
        />
      );
    }

    if (!accessCodes?.length && user.role === 'CREATOR')
      return <Navigate to="/requests" />;

    return <Navigate search={{ accessCodes }} to="/dashboard" />;
  }

  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
};

const AuthSchema = z
  .object({
    courseId: z.number().optional(),
    moduleId: z.number().optional(),
  })
  .merge(AccessCodesSchema);

export const Route = createFileRoute('/_auth')({
  validateSearch: (search) => AuthSchema.parse(search),
  component: AuthPage,
  notFoundComponent: () => <NotFoundContent />,
});
